module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-meetingdetail"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('meetingDetail_title'),
      "url": "/opera/meetingOrder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cityTop"
  }, [_c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t('meetingDetail_orderNo')) + ":"), _c('span', [_vm._v(_vm._s(_vm.$route.params.id))])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.$t('meetingDetail_totalFee')) + ":"), _c('span', [_vm._v("￥" + _vm._s(_vm.totalRate))])])]), _vm._v(" "), _c('mt-swipe', {
    attrs: {
      "auto": 0
    }
  }, _vm._l((_vm.msgInfo), function(item, key) {
    return _c('mt-swipe-item', {
      key: item.catNo
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "topright"
    }, [_vm._v("\n          " + _vm._s(key + 1) + "/" + _vm._s(_vm.msgInfo.length) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "infos"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "iconfont icon-changfangxingbiaoqian"
    }), _vm._v(_vm._s(_vm.$t('meetingDetail_placeInfo')))]), _vm._v(" "), _c('ul', {
      staticClass: "list clearfix"
    }, [_c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_catNo')) + ":"), _c('span', [_vm._v(_vm._s(item.catNo))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_categoryCode')) + ":"), _c('span', [_vm._v(_vm._s(item.category))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_theme')) + ":"), _c('span', [_vm._v(_vm._s(item.theme))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_sta')) + ":"), _c('span', [_vm._v(_vm._s(item.stas))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_placeDes')) + ":"), _c('span', [_vm._v(_vm._s(item.cateringPlaceDescript))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_board')) + ":"), _c('span', [_vm._v(_vm._s(item.board))])]), _vm._v(" "), _c('li', {
      staticClass: "info last",
      staticStyle: {
        "height": "auto"
      }
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_remark')) + ":"), _c('span', [_vm._v(_vm._s(item.remark))])]), _vm._v(" "), _c('li', {
      staticClass: "line"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "infos "
    }, [_c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "iconfont icon-changfangxingbiaoqian"
    }), _vm._v(_vm._s(_vm.$t('meetingDetail_orderInfo')))]), _vm._v(" "), _c('ul', {
      staticClass: "list clearfix"
    }, [_c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_rsvName')) + ": "), _c('span', [_vm._v(_vm._s(item.rsvName))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_tables')) + ":"), _c('span', [_vm._v(_vm._s(item.tables))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_dateBegin')) + ": "), _c('span', [_vm._v(_vm._s(_vm._f("datefomate")(item.dateBegin)) + " ")])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_peopleNumber')) + ": "), _c('span', [_vm._v(_vm._s(item.peopleNumber))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_dateEnd')) + ":"), _c('span', [_vm._v(_vm._s(_vm._f("datefomate")(item.dateEnd)) + " ")])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_linkMan')) + ": "), _c('span', [_vm._v(_vm._s(item.linkMan))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_tel')) + ":"), _c('span', [_c('a', {
      attrs: {
        "href": "tel:" + item.phone
      }
    }, [_vm._v(_vm._s(item.phone))])])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_salesman')) + ":"), _c('span', [_vm._v(_vm._s(item.salesmanDescript))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_company')) + ": "), _c('span', [_vm._v(_vm._s(item.companyName))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_rate')) + ":"), _c('span', [_vm._v("￥" + _vm._s(item.rate))])]), _vm._v(" "), _c('li', {
      staticClass: "info twocol"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_comRate')) + ":"), _c('span', [_vm._v("￥" + _vm._s(item.comRate))])]), _vm._v(" "), _c('li', {
      staticClass: "line"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "infos "
    }, [_c('div', {
      staticClass: "title"
    }, [_c('i', {
      staticClass: "iconfont icon-changfangxingbiaoqian"
    }), _vm._v(_vm._s(_vm.$t('meetingDetail_other')))]), _vm._v(" "), _c('ul', {
      staticClass: "list clearfix"
    }, [_c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_createDate')) + ": "), _c('span', [_vm._v(_vm._s(_vm._f("datefomate2")(item.createDateTime)))])]), _vm._v(" "), _c('li', {
      staticClass: "info"
    }, [_vm._v(_vm._s(_vm.$t('meetingDetail_modifyDate')) + ": "), _c('span', [_vm._v(_vm._s(_vm._f("datefomate2")(item.modifyDateTime)))])])])])])])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c667690c","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/meetingDetail.vue
// module id = 1835
// module chunks = 107